<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref=""></ion-back-button>
    </ion-buttons>
    <ion-title>Settings</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>

  <ion-list *ngIf="authUser">
    <ion-item-divider color="secondary">
      <ion-label>My Info</ion-label>
    </ion-item-divider>
    <ion-item>
      <ion-label>Name</ion-label>
      {{ authUser.first_name }} {{ authUser.last_name}}
    </ion-item>
    <ion-item>
      <ion-label>Phone</ion-label>
      {{ authUser.phone }}
    </ion-item>
  </ion-list>

  <ion-button expand="block" class="ion-margin" (click)="logout()" fill="outline">
    <ion-icon slot="start" name="log-out"></ion-icon>
    Log out
  </ion-button>
</ion-content>